import * as Yup from 'yup';

import { stringRequired_2_100 } from 'lib/forms/YupValidation';

export default Yup.object().shape({
  namePl: stringRequired_2_100(),
  nameEn: stringRequired_2_100(),
  displayedName: Yup.string().max(2, 'Pole może zawierać maksymalnie dwa znaki'),
});
